import React from "react";
import { RenderSiteProps } from "./RenderSite";
import { I18n } from "../i18n";

const Gallery: React.FC<RenderSiteProps> = ({ site }) => {
  const { photos } = site;
  if (!photos?.is_enabled) {
    return null;
  }
  const { color, color_weight, textColor } = site;
  const i18n = I18n(site.language);
  const photoItems = photos.items || [];

  return (
    <section
      id="gallery"
      data-gallery-root
      className={`py-16 bg-${color}-${color_weight - 100}`}
    >
      <div className="mx-auto px-6">
        <h2
          className={`text-4xl font-bold text-${textColor} text-center mb-12 first-letter:uppercase`}
        >
          {photos.title || i18n.Photos}
        </h2>
        {photos.description && (
          <p
            className={`text-${textColor} text-center mb-8 first-letter:uppercase`}
          >
            {photos.description}
          </p>
        )}
        <div className="flex flex-wrap justify-center gap-6">
          {photoItems.map((photo, index) => {
            const altText =
              photo.alt?.trim() || `${i18n.Photo} ${index + 1}`;
            const imageMetadata = photo.image_metadata;
            const photoClassName = "w-full h-full object-cover transition duration-300 group-hover:scale-105";

            return (
              <a
                key={photo.id || `${photo.uri}-${index}`}
                href={photo.uri}
                className="glightbox group w-full sm:w-1/2 md:w-1/3 lg:w-1/4 aspect-[4/3] overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition duration-300 ease-in-out"
                data-gallery="site-gallery"
                data-type="image"
                onClick={(event) => event.preventDefault()}
              >
                <img
                  width={imageMetadata?.width || undefined}
                  height={imageMetadata?.height || undefined}
                  src={photo.uri}
                  alt={altText}
                  className={photoClassName}
                  loading="lazy"
                />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
